var React = require('react');

function TabletScreen (props) {
    return React.createElement("svg",props,React.createElement("rect",{"fillRule":"evenodd","clipRule":"evenodd","fill":"#FFFFFF","width":"162.646","height":"185.26"}));
}

TabletScreen.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"162.646px","height":"185.26px","viewBox":"0 0 162.646 185.26","enableBackground":"new 0 0 162.646 185.26","xmlSpace":"preserve"};

module.exports = TabletScreen;

TabletScreen.default = TabletScreen;
